import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import ptBR from "./locales/pt-BR.json";
import es from "./locales/es.json";
import de from "./locales/de.json";
import {
  DEFAULT_LANGUAGE,
  FALLBACK_LANGUAGES,
} from "./utils/i18n/supportedLanguages";

// Bundled resources per locale, covering FALLBACK_LANGUAGES. These back the
// handful of components using `t()`; the bulk of PAM copy comes from TCM via
// AppStrings, which needs no entry here.
const LOCALE_RESOURCES = {
  en,
  "pt-BR": ptBR,
  es,
  de,
};

i18n.use(initReactI18next).init({
  resources: Object.fromEntries(
    FALLBACK_LANGUAGES.map((lng) => [
      lng,
      { translation: LOCALE_RESOURCES[lng] },
    ]),
  ),
  lng: DEFAULT_LANGUAGE,
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: [...FALLBACK_LANGUAGES],
  // The operator can offer any BCP-47 tag via `available_languages`, so a
  // regional variant of a bundled language (e.g. `en-NG`) must resolve through
  // its base rather than being rejected by `changeLanguage` and snapped to en.
  nonExplicitSupportedLngs: true,
  interpolation: { escapeValue: false },
});

export default i18n;
